import React from 'react';
import { styles } from './InstallTermsNote.css';
import { INSTALL_INCLUSIONS_AND_EXCLUSIONS_PATH, INSTALL_TERMS_PATH } from './utils';

export const InstallTermsNote = () => (
  <div>
    <a href={INSTALL_TERMS_PATH} target="_blank" rel="noopener noreferrer" className={styles.link}>
      View inclusions and exclusions
    </a>

    <div className={styles.note} role="note">
      <strong>Heads up:</strong> Installs availability and pricing may differ in some areas. Price does not include
      delivery. Final pricing shown in checkout. For more information see the{' '}
      <a
        href={INSTALL_INCLUSIONS_AND_EXCLUSIONS_PATH}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.link}
      >
        JB Hi-Fi Installation terms and conditions
      </a>
      .
    </div>
  </div>
);
